import { render, staticRenderFns } from "./proposalDetail.vue?vue&type=template&id=7cc06890&"
import script from "./proposalDetail.vue?vue&type=script&lang=js&"
export * from "./proposalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports